import { Fade } from "react-awesome-reveal";
import IconLogo from "../assets/img/icon-logo.png";
import CurveArrowTwo from "../assets/img/grb.png";

const RoadmapItem = ({ index, title, description }) => {
    return (
        <div className={`shrink-0 flex flex-col ${index % 2 === 0?"justify-end":"justify-start"} mx-[30px] relative w-[220px] after:content-[''] after:absolute after:w-[18px] after:h-[18px] after:rounded-[100%] after:outline after:outline-4 ${index % 2 === 0?"after:bg-[#0FD88A] after:outline-[rgba(15,216,138,0.2)]":"after:bg-[#FFF] after:outline-[rgba(255,255,255,0.6)]"} after:z-[1] after:left-[50%] after:translate-x-[-50%] after:top-[50%] after:translate-y-[-50%]`}>
           <Fade direction={index % 2 === 0?"up":"down"} triggerOnce={true} duration={1500} className={`h-[43%] flex flex-col ${index % 2 === 0?"justify-start":"justify-end"}`}>
                <div className={`flex flex-col relative min-h-[210px] bg-[#FFF] rounded-[20px] before:content-[''] before:w-[0px] before:h-[0px] before:border-[11px] before:border-[transparent] before:border-t-0 before:border-b-[22px] before:absolute ${index % 2 === 0?"before:border-b-[#0ED694] before:top-[-15px]":"before:border-b-[#FFF] before:bottom-[-15px] before:rotate-[180deg]"} before:left-[50%] before:translate-x-[-50%] z-0`}>
                    <div className="w-full inline-flex justify-start md:justify-end items-center">
                        <div className="w-full relative bg-[linear-gradient(204.59deg,#0ED694_15.7%,#02C3EA_67.01%)] rounded-t-[20px] py-2 px-4 text-white not-italic font-[800] text-[18px] leading-[150%] text-center tracking-[0.06em]">{title}</div>
                    </div>
                    <div className="w-full inline-flex justify-center items-center p-3">
                        <div>
                            <div className="text-center text-[#353736] not-italic font-[400] text-[10px] leading-[18px]">
                                <p dangerouslySetInnerHTML={{ __html: description }} />
                            </div>
                        </div>
                    </div>
                </div>
            </Fade>
        </div>
    )
}
const RoadMap = () => {
    const roadMap = [
        {
            title: "Q2 2022",
            description: "Idea Generation<br/>Market Research<br />XertzSwap Project Announcement<br />Marketing and Brand Awareness<br />Deploying of XEZ Token on Cardano Blockchain<br />Seed Sale<br />UI Design of XertzSwap AMM/DEX"
        },
        {
            title: "Q3 2022",
            description: "Pre Sale<br />DEX/CEX Exchange listing<br />Staking Protocol Development<br />XertzSwap Staking Testnet<br />Development of XertzShop & XertzPad<br />XertzSwap Staking Launch"
        },
        {
            title: "Q4 2022",
            description: "XertzShop Marketplace Launch<br />XertzSwap DEX Testnet<br />Smart Contracts Audit<br />Official XertzSwap DEX platform launch"
        },
        {
            title: "Q1 2023",
            description: "Further development of XertzSwap Ecosystem<br />The Journey continues"
        }
    ]

    return (
        <>
            <div id="Roadmap" className='h-full bg-[#FFF] px-[15px] xs:px-[30px] lg:px-[57px] pt-[90px] relative z-0'>
                <div className="animate-ltr-l absolute bg-[rgba(15,216,138,0.2)] blur-[1000px] left-[-461px] top-0 w-full h-full z-0"></div>
                <div className="animate-rtl-l absolute bg-[rgba(1,194,240,0.2)] blur-[1000px] right-[-230px] top-0 w-full h-full z-0"></div>
                <Fade direction="up" triggerOnce={true} duration={1500}> 
                    <div className="text-[#353736] not-italic font-[700] text-[38px] sm:text-[43px] leading-[36px] sm:leading-[150%] text-right relative mb-2 sm:mb-0">
                        Roadmap
                        <img src={IconLogo} alt="icon-logo" className="App-logo absolute top-[0] left-0 sm:right-[400px] z-10 w-[50px]" />
                    </div>
                </Fade>
                <div className="roadmap h-[calc(100%-60px)] w-full pb-2 overflow-y-hidden relative z-10">
                    <div className="flex flex-row gap-5 w-fit h-full py-2 relative my-[0] mx-[auto] after:content-[''] after:absolute after:h-[2px] after:bg-[#0ED694] after:top-[50%] after:left-0 after:right-0">
                        {/* <div className="before:content-[''] before:w-[10px] before:h-[10px] before:bg-[#4F4F4F] before:absolute before:top-[1px] before:left-[30px] md:before:left-[50%] before:translate-x-[calc(-50%+1px)] before:rotate-45 after:content-[''] after:w-[10px] after:h-[10px] after:bg-[#4F4F4F] after:absolute after:bottom-[1px] after:left-[30px] md:after:left-[50%] after:translate-x-[calc(-50%+1px)] after:rotate-45"></div> */}
                        
                        {roadMap.map((items, index) => (
                                <RoadmapItem key={`roadmap_${index}`} index={index+1} title={items.title} description={items.description} />
                        ))}
                    </div>
                </div>
                <img src={CurveArrowTwo} alt="arrow" className="absolute left-[50%] translate-x-[-50%] z-0 w-[160px] bottom-[-5px]" />
            </div>
        </>
    )
}

export default RoadMap;